// extracted by mini-css-extract-plugin
module.exports = {"label":"style_label__3ujyV","inputWrap":"style_inputWrap__3Y7qP","input":"style_input__13Yjc","inputCenter":"style_inputCenter__2QOJT"};